import styled from "@emotion/styled";
import tw from "tailwind.macro";

export const SizesContainer = styled.div`
    ${tw``};
`;
export const SideBarStyled = styled.div`
    ${tw`flex flex-wrap items-start w-1/4 p-4`};
`;

export const Heading = styled.div`
    display: block;
    ${tw`font-bold mb-4`};
`;
export const Sizes = styled.div`
    ${tw`flex flex-wrap`};
`;
// export const SizeBtn = styled.button`
//     ${tw`p-2 h-10 w-10 rounded-full m-1 bg-gray-400`};
// `;
